import { render, staticRenderFns } from "./LdEmailIntegrationsBanner.vue?vue&type=template&id=e4eb1aee"
import script from "./LdEmailIntegrationsBanner.vue?vue&type=script&lang=js"
export * from "./LdEmailIntegrationsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports